// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/intro-box/app/css/app.css
// module id = 596
// module chunks = 0